import { RecordContainer, WorkflowNav } from '@msaf/core-react'
import { useWorkflowState } from '../context/workflow-context'

export function WorkflowContainer({ children }: React.PropsWithChildren<{}>) {
  const { navigationSteps } = useWorkflowState()
  return <RecordContainer workflowNav={<WorkflowNav sections={navigationSteps} />}>{children}</RecordContainer>
}
